// Expand hidden optional sections before moving focus to the first invalid field.
export function focusFirstFormError(form) {
  const field = form?.querySelector("[aria-invalid='true']");
  if (!field) return;
  let ancestor = field.parentElement;
  while (ancestor && ancestor !== form) {
    if (ancestor.tagName === "DETAILS") ancestor.open = true;
    ancestor = ancestor.parentElement;
  }
  field.focus();
}
